import React, {useCallback} from "react";
import {insertRecordFormData, FieldTypes, matchRecordField, wrapArray, _isBlank, isDisplayStatus} from "../../utils";
import _ from "lodash";
import {fieldQuery} from "../../../helpers/query";
import RecordSearch from "../../RecordSearch";
import {useField, useFormikContext} from "formik";
import {useStore} from "../../../@redux";

export const getSearchFields = (extraConfig:any) => {
    return _.get(extraConfig,'search_fields.fields', [])
}
export const getFilterFields = (extraConfig:any) => {
    const mode = _.get(extraConfig, 'filter_dep_mode', 'none')
    return mode === 'fields' ? _.get(extraConfig,'dep_fields.fields', []) : []
}
export const getDynamicFilterFields = (extraConfig:any) => {
    return _.get(extraConfig,'dynamic_filters.fields', [])
}
export const processControlsWithLookup = (details: any, extraConfig, store, more:any = {}) => {
    const {controls = {} } = extraConfig
    const disabled = isDisplayStatus(extraConfig, 'disable')
    const {allow_more = true, allow_lookup = true} = more
    const newControls = _.cloneDeep({...controls, ...more})
    const {valid:lookupValid} = getFilterValues(details, extraConfig, store)
    console.log('processControlsWithLookup', newControls, lookupValid, extraConfig)
    if(disabled || !lookupValid || !allow_lookup){
        _.set(newControls, 'disabled.lookup', true)
    }
    if(disabled || !allow_more){
        _.set(newControls, 'disabled.create', true)
    }
    if(disabled){
        _.set(newControls, 'disabled.edit', true)
    }
    if(_.has(more,'allow_more'))console.log('**processControlsWithLookup**', {newControls,lookupValid,allow_more,allow_lookup, more})
    return newControls
}
export const getFilterValues = (details:any, extraConfig:any, store:any ) => {
    const filterFields = getFilterFields(extraConfig)
    const dynamicFields = getDynamicFilterFields(extraConfig)
    const values = {}
    let valid = true
    let errors = []
    console.log('Starting Filter Values', details.path,filterFields,dynamicFields, store.formData?.data, details,extraConfig)
    for(let depField of filterFields){
        let found = false
        const {form:depFormId = '', field: depFieldId = ''} = depField.field || {}
        for(let fPath of details.path){//make sure get field values from correct forms in our path
            const formData = _.get(store,`formData.data.${fPath}`,{}) as any
            if(formData.form_code === depFormId && _.has(formData.data,depFieldId)){
                if(!values[depFormId])values[depFormId] = {}
                values[depFormId][depFieldId] = _.get(formData.data, depFieldId)
                if(!_isBlank(values[depFormId][depFieldId]))found = true
                console.log("**Adding Filter Value**", {values:JSON.stringify(values), depFormId, depFieldId, data:formData.data, get: _.get(formData.data, depFieldId)})
            }
            console.log('**Checking Filter Values', {fPath, depField, depFormId,depFieldId, formData, values, extraConfig, found})
        }
        if(depField.required && !found){
            valid = false
            errors.push(depField)
        }
    }
    for(let dynField of dynamicFields){
        if(dynField.required && dynField.url_param && _isBlank(_.get(details.params, dynField.url_param))){
            valid = false
            errors.push(dynField)
        }
    }
    return {valid,values, errors}
}
export const getDisplayFields = (extraConfig:any) => {
    return _.filter( _.get(extraConfig,'display_fields.fields', []), f => _.get(f,'show.lookup'))
    // if(extraConfig.search_fields && extraConfig.search_fields.length){
    //     return extraConfig.search_fields
    // }
    // let defaultSearch = []
    // if(extraConfig.primary_field)defaultSearch.push(extraConfig.primary_field)
    // if(extraConfig.secondary_field)defaultSearch.push(extraConfig.secondary_field)
    // defaultSearch = defaultSearch.concat( extraConfig.sub_fields || [] )
    // if(defaultSearch.length)return defaultSearch
    // return [{name:true}]
}

const searchElements = (formPath: string[], props: any, state: any, removeExistingRecords = false) => {
    const store = useStore()

    const {details, extraConfig = {} as any} = props
    //const {query_once_filter_local = false} = extraConfig
    const query_once_filter_local = false //not supported yet (maybe never?)
    const {values, field, setRecords, setFilteredRecords, setInQuery, records, filteredRecords, isInQuery} = state
    const {values:depValues} = getFilterValues(details, extraConfig, store)
    console.log('**SearchElements**', {depValues,formPath,store,details,extraConfig})
   const removeExisting = ( list ) =>  removeExistingRecords ? list.filter( rec => !wrapArray(field.value).find( frec => frec.tableRecordId === rec.tableRecordId ) ) : list

    const doFilterLocal = useCallback((query, newFullRecords = undefined) => {

        if (query_once_filter_local) {
            const searchFields = getSearchFields(extraConfig)
            if (newFullRecords) setRecords(newFullRecords)
            const newFilteredRecords = (newFullRecords || records || []).filter(rec => {
                for (let sf of searchFields) {
                    if (matchRecordField(query, rec, sf)) return true
                }
                return false
            })
            const newList = removeExisting(newFilteredRecords)

            setFilteredRecords(insertRecordFormData(null, newList, store))
            return newList
        }
        return filteredRecords
    }, [records, query_once_filter_local,field.value, removeExistingRecords, extraConfig, store])

    const onQuery = useCallback((query = null, after = null) => {

        if (_.isObject(query as any)) query = query.query
        console.log('On Query', query, isInQuery, query_once_filter_local, records, details, props)
        if (!isInQuery) {
            if (query_once_filter_local && records !== null) {
                doFilterLocal(query)
            } else {
                setInQuery(true)
                console.log('Query Record Search', query, depValues, extraConfig, field, details, store)
                fieldQuery(details.root_code, details.mode, details.form_id, field.name, depValues, details.params, query_once_filter_local ? null : query, details.record_id, res => {
                    setInQuery(false)
                    let results = res.results
                    let fullResults = results
                    if (query_once_filter_local) {
                        results = doFilterLocal(query, results)
                    } else {
                        results = removeExisting(results)
                        fullResults = insertRecordFormData(null, results, store)
                        setFilteredRecords(fullResults)
                    }
                    console.log("Settings Result Records", res)
                    if (after) after(results, fullResults)
                })
            }
        }
    }, [query_once_filter_local, records, isInQuery, setInQuery, details, field, values,store])


    return {getSearchFields, doFilterLocal,onQuery}
}

export default searchElements